import type { ScrapingHeroAction } from '@/blocks/ScrapingHero/types';

const DEMO_DELAY_MIN_MS = 2_000;
const DEMO_DELAY_RANGE_MS = 4_000;

const preScrapedPayloads = {
  scrape: {
    'https://github.com': {
      results: [
        {
          content:
            '<!DOCTYPE html><html lang="en"><head>\n    <meta charset="utf-8">\n\t<title>GitHub · Build and ship software on a single, collaborative platform · GitHub</title>\n    <meta name="description" content="GitHub is where people build software. More than 100 million people use GitHub to discover, fork, and contribute to over 420 million projects.">',
          status_code: 200,
          url: 'https://github.com',
        },
      ],
      truncated: true,
    },
    'https://chatgpt.com': {
      results: [
        {
          content:
            '<!DOCTYPE html><html lang="en-US"><head>\n    <meta charset="utf-8">\n\t<title>ChatGPT</title>\n    <meta name="description" content="ChatGPT helps you get answers, find inspiration, and be more productive.">',
          status_code: 200,
          url: 'https://chatgpt.com',
        },
      ],
      truncated: true,
    },
    'https://amazon.com': {
      results: [
        {
          content:
            '<!DOCTYPE html><html lang="en-us" class="a-ws a-js a-audio a-video a-canvas a-svg a-drag-drop a-geolocation a-history a-webworker a-autofocus a-input-placeholder a-textarea-placeholder a-local-storage a-gradients a-transform3d a-touch-scrolling a-text-shadow a-text-stroke a-box-shadow a-border-radiu...',
          status_code: 200,
          url: 'https://amazon.com',
        },
      ],
      truncated: true,
    },
    'https://zillow.com': {
      results: [
        {
          content:
            '<!DOCTYPE html><html lang="en-US"><head>\n    <meta charset="utf-8">\n\t<title>Zillow: Real Estate, Apartments, Mortgages & Home Values</title>\n    <meta name="description" content="Zillow has 110 million homes across the country, plus rental listings, home values, and school ratings.">',
          status_code: 200,
          url: 'https://zillow.com',
        },
      ],
      truncated: true,
    },
  },
  search: {
    laptop: {
      status: 'done',
      organic: [
        {
          title: 'PC Laptop, Notebook',
          desc: 'Shop all new laptops at Best Buy . Compare and read reviews on the vast selection of laptop computers, notebooks and new PC and Mac laptops.',
          link: 'https://www.bestbuy.com',
        },
        {
          title: 'Laptop',
          desc: 'A laptop is a portable personal computer (PC). Laptops typically have a clamshell form factor with a flat-panel screen on the inside of the upper lid and an ... Read more',
          link: 'https://en.wikipedia.org',
        },
        {
          title:
            'Computers & Tablets: Electronics: Traditional Laptops, 2 in ...',
          desc: 'Shop a wide selection of Laptops including 2 in 1 and traditional laptops at Amazon.com. Free shipping and free returns on eligible items.',
          link: 'https://www.amazon.com',
        },
      ],
      truncated: true,
    },
  },
  map: {
    'https://github.com': {
      urls: [
        'https://github.com',
        'https://github.com/features',
        'https://github.com/pricing',
        'https://github.com/about',
      ],
      truncated: true,
    },
    'https://chatgpt.com': {
      urls: [
        'https://chatgpt.com',
        'https://chatgpt.com/auth/login',
        'https://chatgpt.com/gpts',
      ],
      truncated: true,
    },
    'https://amazon.com': {
      urls: [
        'https://amazon.com',
        'https://amazon.com/gp/bestsellers',
        'https://amazon.com/gp/new-releases',
      ],
      truncated: true,
    },
    'https://zillow.com': {
      urls: [
        'https://zillow.com',
        'https://zillow.com/homes',
        'https://zillow.com/mortgage-rates',
        'https://zillow.com/rentals',
      ],
      truncated: true,
    },
  },
  crawl: {
    'https://github.com': {
      crawl_id: 'crawl_demo_github_com',
    },
    'https://chatgpt.com': {
      crawl_id: 'crawl_demo_chatgpt_com',
    },
    'https://amazon.com': {
      crawl_id: 'crawl_demo_amazon_com',
    },
    'https://zillow.com': {
      crawl_id: 'crawl_demo_zillow_com',
    },
  },
} as const satisfies Partial<
  Record<ScrapingHeroAction, Record<string, unknown>>
>;

export function getPreScrapedPayload(
  endpoint: ScrapingHeroAction,
  url: string
): unknown | null {
  const endpointPayloads = preScrapedPayloads[endpoint];
  if (!endpointPayloads) return null;

  return endpointPayloads[url as keyof typeof endpointPayloads] ?? null;
}

export function demoDelayMs() {
  return DEMO_DELAY_MIN_MS + Math.random() * DEMO_DELAY_RANGE_MS;
}
